import React from 'react'
import NavBar from "./NavBar";
import Footer from "./Footer";

const AbtSchemeUI = () => { return ( 
<div>
    <NavBar />
    <main id="main">
        <section id="abtScheme" class="innerPage">
            <div class="container">
                <div class="section-title">
                    <h2>റീട്ടെയിൽ ഡയറക്ട് സ്കീം</h2>
                </div>
                <div>
                    <p>
                        സർക്കാർ സെക്യൂരിറ്റികളിൽ റീട്ടെയിൽ സെയിൽസ് പങ്കാളിത്തം വർദ്ധിപ്പിക്കുന്നതിനുള്ള തുടർ ശ്രമങ്ങളുടെ ഭാഗമായി, 2021 ഫെബ്രുവരി 05 ലെ ഡെവലപ്‌മെന്‍റൽ ആൻഡ് റെഗുലേറ്ററി നയങ്ങളുടെ പ്രസ്താവനയിൽ 'RBI റീട്ടെയിൽ ഡയറക്ട്' സൗകര്യം പ്രഖ്യാപിച്ചു. RBI-യിൽ ഗിൽറ്റ് സെക്യൂരിറ്റീസ് അക്കൗണ്ട് ('റീട്ടെയിൽ ഡയറക്‌ട്') തുറക്കാനുള്ള സൗകര്യത്തോടൊപ്പം, ഓൺലൈൻ ആക്‌സസ് വഴി റീട്ടെയിൽ നിക്ഷേപകർക്ക് പ്രൈമറി, സെക്കണ്ടറി സെക്യൂരിറ്റീസ് മാർക്കറ്റിലേക്കുള്ള പ്രവേശനം എളുപ്പമാക്കുന്നതിനാണ് ഇത് ചെയ്തിരിക്കുന്നത്.
                    </p>
                    <p>
                        ഈ പ്രഖ്യാപനത്തിന് അനുസൃതമായി, വ്യക്തിഗത നിക്ഷേപകർക്ക് സർക്കാർ സെക്യൂരിറ്റികളിൽ നിക്ഷേപം സുഗമമാക്കുന്നതിനുള്ള ഒറ്റത്തവണ പരിഹാരമായ ‘RBI റീട്ടെയിൽ ഡയറക്ട്’ പദ്ധതി പുറത്തിറക്കി. ‘RBI റീട്ടെയിൽ ഡയറക്ട്’ പദ്ധതിയുടെ പ്രത്യേകതകൾ ഇവയാണ്:
                    </p>
                    <ol>
                        <li>
                            റീട്ടെയിൽ നിക്ഷേപകർക്ക് (വ്യക്തികൾക്ക്) ‘റീട്ടെയിൽ ഡയറക്ട് ഗിൽറ്റ് അക്കൗണ്ട്’ (ആർ.ഡി.ജി. അക്കൗണ്ട്) തുറക്കാനും പരിപാലിക്കാനുമുള്ള സൗകര്യം ഉണ്ടായിരിക്കും.
                        </li>
                        <li>
                            സ്കീമിന്‍റെ ആവശ്യത്തിനായി നൽകിയിരിക്കുന്ന 'ഓൺലൈൻ പോർട്ടൽ' വഴി ആർ.ഡി.ജി. അക്കൗണ്ട് തുറക്കാവുന്നതാണ്.
                        </li>

                        <li>
                            രജിസ്റ്റർ ചെയ്ത ഉപയോക്താക്കൾക്ക് 'ഓൺലൈൻ പോർട്ടൽ' ഇനിപ്പറയുന്ന സൗകര്യങ്ങളും നൽകും:
                            <ol>
                                <li>
                                    സർക്കാർ സെക്യൂരിറ്റികളുടെ പ്രൈമറി ഇഷ്യൂവിലേക്കുള്ള പ്രവേശനം
                                </li>
                                <li>
                                    എൻ.ഡി.എസ്.-ഒ.എം.-ലേക്കുള്ള ആക്സസ്.
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <p>
                       വ്യക്തിഗത നിക്ഷേപകർക്ക് സർക്കാർ സെക്യൂരിറ്റികളിലെ നിക്ഷേപം സുഗമമാക്കുന്നതിനുള്ള ഒറ്റത്തവണ പരിഹാരമായാണ് റിസർവ് ബാങ്ക് ഓഫ് ഇന്ത്യ (RBI) റീട്ടെയിൽ ഡയറക്‌ട് പദ്ധതി രൂപപ്പെടുത്തിയിരിക്കുന്നത്.
                    </p>
                    <h5>I. നിർവചനങ്ങൾ</h5>
                    <p>
                        ഈ ഡോക്യുമെന്‍റിൽ ഉപയോഗിച്ചിരിക്കുന്ന നിബന്ധനകൾക്ക് നൽകിയിരിക്കുന്ന അർത്ഥം ഇനിപ്പറയുന്നവയാണ്:
                        <ol type="i">
                            <li>
                                എ. അഗ്രിഗേറ്റർ / റിസീവിംഗ് ഓഫീസ് എന്നാൽ ക്ലിയറിംഗ് കോർപ്പറേഷൻ ഓഫ് ഇന്ത്യ ലിമിറ്റഡ് (സി.സി.ഐ.എൽ.) അല്ലെങ്കിൽ സ്കീമിന് കീഴിൽ RBI അംഗീകരിച്ചേക്കാവുന്ന മറ്റേതെങ്കിലും സ്ഥാപനം എന്നാണ് അർത്ഥമാക്കുന്നത്;
                            </li>
                            <li>

                                ബി. ഈ സ്‌കീമിന്‍റെ ആവശ്യത്തിനുള്ള സർക്കാർ സെക്യൂരിറ്റികൾ എന്നത് കൊണ്ട് അർത്ഥമാക്കുന്നത് സർക്കാർ സെക്യൂരിറ്റീസ് ആക്ട് 2006-ന്‍റെ വകുപ്പ് 3(iii) പ്രകാരം RBI-ൽ പരിപാലിക്കുന്ന എസ്.ജി.എൽ./സി.എസ്.ജി.എൽ. അക്കൗണ്ടിലേക്ക് ക്രെഡിറ്റ് വഴി സ്റ്റോക്ക് രൂപത്തിൽ ഇഷ്യൂ ചെയ്യുന്ന സെക്യൂരിറ്റികളാണ്. ഇതിൽ ഉൾപ്പെടുന്നവ:
                                <br/> i) ഇന്ത്യാ ഗവൺമെന്‍റ് ട്രഷറി ബില്ലുകൾ;<br/> ii) ഇന്ത്യാ ഗവൺമെന്‍റ് തീയതി രേഖപ്പെടുത്തിയ സെക്യൂരിറ്റികൾ;<br/> iii) സോവറിൻ ഗോൾഡ് ബോണ്ടുകൾ (SGB);<br/> iv) സംസ്ഥാന വികസന വായ്പകൾ (SDLs)<br/>

                            </li> 

                            <li> സി.സി.ഐ.എൽ.-ലെ അംഗം/അസോസിയേറ്റ് അംഗം എന്നാൽ അംഗത്വ നയം അനുസരിച്ച് സി.സി.ഐ.എൽ. അംഗത്വം ലഭിച്ച സ്ഥാപനങ്ങൾ എന്നാണ് അർത്ഥമാക്കുന്നത്; </li>
                            <li> എൻ.ഡി.എസ്.-ഒ.എം. എന്നാൽ സെക്കണ്ടറി മാർക്കറ്റിൽ സർക്കാർ സെക്യൂരിറ്റികളിൽ വ്യാപാരം നടത്തുന്നതിനുള്ള RBI-യുടെ സ്‌ക്രീൻ അടിസ്ഥാനമാക്കിയുള്ള, അജ്ഞാത ഇലക്ട്രോണിക് ഓർഡർ മാച്ചിംഗ് സിസ്റ്റം എന്നാണ് അർത്ഥമാക്കുന്നത്;</li>
                            <li> ഓട് ലോട്ട് സെഗ്മെന്‍റ് എന്നാൽ  എൻ.ഡി.എസ്.-ഒ.എം.-ന്‍റെ ഓട് ലോട്ട് സെഗ്മെന്‍റ് എന്നാണ് അർത്ഥമാക്കുന്നത്;</li>
                            <li> ഒ.ടി.പി. എന്നാൽ ഒറ്റത്തവണ-പാസ്‌വേഡ് എന്നാണ് അർത്ഥമാക്കുന്നത്; </li>
                            <li> ഒ.വി.ഡി., RBI, നിങ്ങളുടെ ഉപഭോക്താവിനെ അറിയുക (കെ.വൈ.സി.) നിർദ്ദേശം 2016-ന് കീഴിൽ നിർവചിച്ചിരിക്കുന്ന ഔദ്യോഗികമായി സാധുതയുള്ള രേഖ എന്നാണ് അർത്ഥമാക്കുന്നത്, ഇത് കാലാകാലങ്ങളിൽ ഭേദഗതി വരുത്തുന്നു; </li>
                            <li> ഓൺലൈൻ പോർട്ടൽ എന്നാൽ RBI റീട്ടെയിൽ ഡയറക്ട് ഓൺലൈൻ പോർട്ടൽ എന്നാണ് അർത്ഥമാക്കുന്നത്. </li>
                            <li> റീട്ടെയിൽ ഡയറക്ട് ഗിൽറ്റ് അക്കൗണ്ട് (ആർ.ഡി.ജി. അക്കൗണ്ട്) എന്നാൽ ഈ സ്കീമിന് കീഴിൽ RBI-യുടെ ബുക്കുകളിൽ സൂക്ഷിച്ചിരിക്കുന്ന ഗിൽറ്റ് അക്കൗണ്ട് എന്നാണ് അർത്ഥമാക്കുന്നത്; </li>
                            <li> റീട്ടെയിൽ നിക്ഷേപകർ എന്നാൽ വ്യക്തികൾ (സ്വാഭാവിക വ്യക്തികൾ) എന്നാണ് അർത്ഥമാക്കുന്നത്; </li>
                            <li> നിരക്കുവിലയ്ക്കുള്ള അഭ്യർത്ഥന (ആർ.എഫ്‌.ക്യു.) മോഡ് എന്നാൽ RBI-യുടെ എൻ.ഡി.എസ്.-ഒ.എം. സിസ്റ്റത്തിന്‍റെ ഓൺ-സ്ക്രീൻ നെഗോഷ്യേഷൻ സിസ്റ്റം എന്നാണ് അർത്ഥമാക്കുന്നത്; </li>
                            <li> എസ്.എം.എസ്. എന്നാൽ ഹ്രസ്വ സന്ദേശ സേവനം എന്നാണ് അർത്ഥമാക്കുന്നത്. </li>
                            <li> വി.എഫ്.ടി. എന്നാൽ 2018 നവംബർ 16-ലെ RBI വിജ്ഞാപനം അനുസരിച്ച് കാലാകാലങ്ങളിൽ ഭേദഗതി വരുത്തിയ സർക്കാർ സെക്യൂരിറ്റികളുടെ 'മൂല്യരഹിത കൈമാറ്റം' എന്നാണ് അർത്ഥമാക്കുന്നത്.
                            </li>
                        </ol>
                    </p>

                    <h5>II. സ്കീമിന്‍റെ പരിധി </h5>
                    <ol>
                        <li type="a">
                            ഒരു ഓൺലൈൻ പോർട്ടലിലൂടെ സർക്കാർ സെക്യൂരിറ്റീസ് മാർക്കറ്റിലെ റീട്ടെയിൽ നിക്ഷേപകർക്ക് ഇനിപ്പറയുന്ന സൗകര്യങ്ങൾ പ്രദാനം ചെയ്യുന്ന ഒരു സമഗ്ര പദ്ധതിയാണ് RBI റീട്ടെയിൽ ഡയറക്റ്റ്':
                            <ol type="i">


                                <li> ഒരു ‘റീട്ടെയിൽ ഡയറക്ട് ഗിൽറ്റ് അക്കൗണ്ട്’ (ആർ.ഡി.ജി. അക്കൗണ്ട്) തുറന്ന് പരിപാലിക്കുക </li>
                                <li> സർക്കാർ സെക്യൂരിറ്റികളുടെ പ്രൈമറി ഇഷ്യൂവിലേക്കുള്ള പ്രവേശനം </li>
                                <li> എൻ.ഡി.എസ്.-ഒ.എം.-ലേക്കുള്ള ആക്സസ്</li>
                            </ol>
                        </li>
                    </ol>
                    <h5>III. യോഗ്യത </h5>
                    <p>
                        <ol type="a">
                            <li> സ്കീമിന് കീഴിൽ നിർവചിച്ചിരിക്കുന്നതുപോലെ, റീട്ടെയിൽ നിക്ഷേപകർക്ക് ഇനിപ്പറയുന്നവ ഉണ്ടെങ്കിൽ, സ്കീമിന് കീഴിൽ രജിസ്റ്റർ ചെയ്യാനും ഒരു ആർ.ഡി.ജി. അക്കൗണ്ട് നിലനിർത്താനും കഴിയും:
                                <ol type="i">


                                    <li> ആദായ നികുതി വകുപ്പ് നൽകുന്ന പെർമനന്‍റ് അക്കൗണ്ട് നമ്പർ (പാൻ);</li>
                                    <li> സർക്കാർ സെക്യൂരിറ്റികളുടെ പ്രൈമറി ഇഷ്യൂവിലേക്കുള്ള പ്രവേശനം </li>
                                    <li> കെ‌.വൈ‌.സി. ആവശ്യത്തിനുള്ള ഏതെങ്കിലും ഒ.വി.ഡി.; </li>
                                    <li> സാധുവായ ഇ-മെയിൽ ഐ.ഡി.; ഒപ്പം </li>
                                    <li> രജിസ്റ്റർ ചെയ്ത മൊബൈൽ നമ്പർ </li>
                                </ol>

                            </li>
                            <li>
                                1999-ലെ ഫോറിൻ എക്‌സ്‌ചേഞ്ച് മാനേജ്‌മെന്‍റ് ആക്‌ട് പ്രകാരം സർക്കാർ സെക്യൂരിറ്റികളിൽ നിക്ഷേപിക്കാൻ യോഗ്യരായ പ്രവാസികളായ റീട്ടെയിൽ നിക്ഷേപകർക്ക് പദ്ധതിക്ക് കീഴിൽ നിക്ഷേപിക്കാൻ അർഹതയുണ്ട്.

                            </li>
                            <li>
                                ആർ.ഡി.ജി. അക്കൗണ്ട് ഒറ്റയ്ക്കോ അല്ലെങ്കിൽ യോഗ്യതാ മാനദണ്ഡങ്ങൾ പാലിക്കുന്ന മറ്റൊരു റീട്ടെയിൽ നിക്ഷേപകനുമായി ചേർന്നോ തുറക്കാവുന്നതാണ്.
                            </li>
                        </ol>
                    </p>
                    <h5> IV. നടപടിക്രമം</h5>
                    <p>

                        രജിസ്ട്രേഷൻ
                        <ol type="i">

                            <li>
                                നിക്ഷേപകർക്ക് ഓൺലൈൻ ഫോം പൂരിപ്പിച്ച് ഓൺലൈൻ പോർട്ടലിൽ രജിസ്റ്റർ ചെയ്യാനും രജിസ്റ്റർ ചെയ്ത മൊബൈൽ നമ്പറിലും ഇ-മെയിൽ ഐ.ഡി.-യിലും ലഭിക്കുന്ന ഒ.ടി.പി. ഉപയോഗിച്ച് ഫോം പ്രാമാണീകരിക്കാനും സമർപ്പിക്കാനും കഴിയും. </li>

                            <li>
                                RBI-നിങ്ങളുടെ ഉപഭോക്താവിനെ അറിയുക (കെ‌.വൈ‌.സി.) നിർദ്ദേശം, 2016-ന് കീഴിൽ നൽകിയിരിക്കുന്ന നിർദ്ദേശങ്ങൾ, കാലാകാലങ്ങളിൽ അപ്‌ഡേറ്റ് ചെയ്യുന്നു, ഇത് നിക്ഷേപകരെ ഓൺ‌ബോർഡിംഗ് ചെയ്യുമ്പോൾ പാലിക്കേണ്ടതാണ്. വിജയകരമായ രജിസ്ട്രേഷന് ശേഷം, ‘റീട്ടെയിൽ ഡയറക്ട് ഗിൽറ്റ് അക്കൗണ്ട്’ തുറക്കുകയും ഓൺലൈൻ പോർട്ടൽ ആക്സസ് ചെയ്യുന്നതിനുള്ള വിശദാംശങ്ങൾ എസ്.എം.എസ്./ഇ-മെയിൽ വഴി അറിയിക്കുകയും ചെയ്യും.
                            </li>
                            <li>
                                എൻ.ഡി.എസ്.-ഒ.എം.-ൽ പ്രൈമറി മാർക്കറ്റ് പങ്കാളിത്തത്തിനും സെക്കൻഡറി മാർക്കറ്റ് ഇടപാടുകൾക്കും ആർ.ഡി.ജി. അക്കൗണ്ട് ലഭ്യമാണ്.
                            </li>
                            <p> പ്രൈമറി മാർക്കറ്റ് പങ്കാളിത്തം </p>
                            <li>
                                സെക്യൂരിറ്റികളുടെ പങ്കാളിത്തവും അനുവദിക്കലും സർക്കാർ സെക്യൂരിറ്റികളുടെ പ്രാഥമിക ലേലം, എസ്.ജി.ബി. ഇഷ്യു ചെയ്യുന്നതിനുള്ള നടപടിക്രമ മാർഗ്ഗനിർദ്ദേശങ്ങൾ എന്നിവയിൽ  പങ്കെടുക്കുന്നതിനുള്ള നോൺ-കോമ്പറ്റിറ്റീവ് പദ്ധതി പ്രകാരമായിരിക്കും.

                            </li>
                            <li>
                                ഒരു സെക്യൂരിറ്റിക്ക് ഒരു ബിഡ് മാത്രമേ അനുവദിക്കൂ. ബിഡ് സമർപ്പിക്കുമ്പോൾ, അടയ്‌ക്കേണ്ട മൊത്തം തുക കാണിക്കും.
                            </li>
                            <li>
                                അഗ്രിഗേറ്റർ / റിസീവിംഗ് ഓഫീസ് എന്നതിലേക്കുള്ള പേയ്‌മെന്‍റ് ഇനിപ്പറയുന്ന ഏതെങ്കിലും മാർഗ്ഗങ്ങളിലൂടെ നടത്താം:
                                <ol type="a">
                                    <li>

                                        ലിങ്ക് ചെയ്‌ത ബാങ്ക് അക്കൗണ്ടിൽ നിന്നുള്ള നെറ്റ്-ബാങ്കിംഗ്/യു.പി.ഐ. സൗകര്യം ഉപയോഗിച്ച്, പോർട്ടലിൽ ബിഡ്ഡുകൾ സമർപ്പിക്കുന്ന സമയത്ത് ഫണ്ടുകൾ ഡെബിറ്റ് ചെയ്യപ്പെടും.
                                    </li>
                                    <li>
                                        പോർട്ടലിൽ ബിഡ് സമർപ്പിക്കുന്ന സമയത്ത്, ലേലത്തിന്‍റെ വിജയകരമായ അനുവദിക്കലിന് ശേഷം ലിങ്ക് ചെയ്‌ത ബാങ്ക് അക്കൗണ്ടിലെ ഫണ്ടുകൾ ബ്ലോക്ക് ചെയ്യാൻ കഴിയുന്ന യു.പി.ഐ. സൗകര്യം ഉപയോഗിച്ച് ഈ അക്കൗണ്ടിൽ നിന്ന് പണം ഡെബിറ്റ് ചെയ്യപ്പെടും. ബാങ്കുകൾ വഴിയുള്ള സമാനമായ സൗകര്യം യഥാസമയം ലഭ്യമാക്കും.
                                    </li>
                                    <li>
                                        റീഫണ്ട്, എന്തെങ്കിലും ഉണ്ടെങ്കിൽ, അഗ്രിഗേറ്റർ വ്യക്തമാക്കിയ സമയക്രമം അനുസരിച്ച് നിക്ഷേപകന്‍റെ ബാങ്ക് അക്കൗണ്ടിലേക്ക് ക്രെഡിറ്റ് ചെയ്യപ്പെടും.
                                    </li>
                                </ol>


                            </li>
                            <li>
                                നിക്ഷേപകർക്ക് അനുവദിച്ച സെക്യൂരിറ്റികൾ സെറ്റിൽമെന്‍റ് ദിവസം അവരുടെ ആർ.ഡി.ജി. അക്കൗണ്ടിലേക്ക് ക്രെഡിറ്റ് ആയി നൽകും.
                            </li>

                            <p> സെക്കൻഡറി മാർക്കറ്റ് ഇടപാട്-എൻ.ഡി.എസ്.-ഒ.എം. </p>
                            <li>
                                രജിസ്റ്റർ ചെയ്ത നിക്ഷേപകർക്ക് എൻ.ഡി.എസ്.-ഒ.എം. (ഓഡ് ലോട്ട് സെഗ്‌മെന്‍റ്/ആർ.എഫ്‌.ക്യു.) വഴി സർക്കാർ സെക്യൂരിറ്റികൾ വാങ്ങാനോ വിൽക്കാനോ ഓൺലൈൻ പോർട്ടലിലെ സെക്കൻഡറി മാർക്കറ്റ് ഇടപാട് ലിങ്ക് ആക്‌സസ് ചെയ്യാൻ കഴിയും.
                            </li>
                            <p> വാങ്ങൽ </p>
                            <li>
                                ഇനിപ്പറയുന്ന ഏതെങ്കിലും വഴികളിലൂടെ പേയ്‌മെന്‍റ് നടത്താം:
                                <ol type="a">
                                    <li>
                                        ട്രേഡിംഗ് സമയം ആരംഭിക്കുന്നതിന് മുമ്പോ ആ ദിവസം തന്നെയോ, നിക്ഷേപകൻ ലിങ്ക് ചെയ്‌ത ബാങ്ക് അക്കൗണ്ടിൽ നിന്ന് നെറ്റ്-ബാങ്കിംഗ്/യു.പി.ഐ. ഉപയോഗിച്ച്  (ക്ലിയറിംഗ് കോർപ്പറേഷൻ ഓഫ് എൻ.ഡി.എസ്.-ഒ.എം.)-ന്‍റെ നിയുക്ത അക്കൗണ്ടിലേക്ക് ഫണ്ട് ട്രാൻസ്ഫർ ചെയ്യണം. യഥാർത്ഥ കൈമാറ്റം/വിജയ സന്ദേശത്തെ അടിസ്ഥാനമാക്കി, 'വാങ്ങൽ' ഓർഡറുകൾ നൽകുന്നതിന് ഒരു ഫണ്ടിംഗ് പരിധി (വാങ്ങൽ പരിധി) നൽകും. ട്രേഡിംഗ് വിഭാഗത്തിന്‍റെ അവസാനം, നിക്ഷേപകന്‍റെ ക്രെഡിറ്റിൽ കിടക്കുന്ന ഏതെങ്കിലും അധിക ഫണ്ടുകൾ റീഫണ്ട് ചെയ്യും.
                                    </li>
                                    <li>
                                        യു.പി.ഐ. സൗകര്യം ഉപയോഗിച്ച്, ഓർഡർ നൽകുമ്പോൾ ലിങ്ക് ചെയ്‌ത ബാങ്ക് അക്കൗണ്ടിലെ ഫണ്ടുകൾ ബ്ലോക്ക് ചെയ്യാവുന്നതാണ്, അത് സെറ്റിൽമെന്‍റ് ദിവസം ഈ അക്കൗണ്ടിൽ നിന്ന് ഡെബിറ്റ് ചെയ്യപ്പെടും. ബാങ്കുകൾ വഴിയുള്ള സമാനമായ സൗകര്യം യഥാസമയം ലഭ്യമാക്കും.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                വാങ്ങിയ സെക്യൂരിറ്റികൾ സെറ്റിൽമെന്‍റ് ദിവസം ആർ.ഡി.ജി. അക്കൗണ്ടിലേക്ക് ക്രെഡിറ്റ് ചെയ്യപ്പെടും.
                            </li>
                            <p> വിൽക്കൽ </p>
                            <li>
                                വിൽപ്പനയ്‌ക്കായി കണ്ടെത്തിയ സെക്യൂരിറ്റികൾ ഓർഡർ നൽകുന്ന സമയത്ത് ട്രേഡ് തീർപ്പാക്കുന്നതുവരെ ബ്ലോക്ക് ചെയ്യപ്പെടും.

                            </li>
                            <li>
                                വിൽപന ഇടപാടുകളിൽ നിന്നുള്ള പണം സെറ്റിൽമെന്‍റ് ദിവസം ലിങ്ക് ചെയ്ത ബാങ്ക് അക്കൗണ്ടിലേക്ക് ക്രെഡിറ്റ് ചെയ്യപ്പെടും.
                            </li>
                            <p> നോൺ-ട്രേഡ് ഇടപാടുകൾ - മൂല്യരഹിത ഇടപാടുകൾ (വി.എഫ്.ടി.) </p>
                            <li>
                                റീട്ടെയിൽ നിക്ഷേപകർക്ക് ബാധകമാകുന്ന തരത്തിൽ കാലാകാലങ്ങളിൽ ഭേദഗതി വരുത്തി 2018 നവംബർ 16-ന് ആർബിഐ പുറപ്പെടുവിച്ച വി.എഫ്.ടി. മാർഗ്ഗനിർദ്ദേശങ്ങൾ പ്രകാരം അനുവദനീയമായ ഇടപാടുകൾ സ്കീമിന് കീഴിൽ ലഭ്യമാകും.
                            </li>
                            <li>
                            അത്തരം ആവശ്യങ്ങൾക്കായി, നിക്ഷേപകർ ഓൺലൈൻ പോർട്ടലിൽ ഒരു അപേക്ഷ സമർപ്പിക്കണം.
                            </li>
                        </ol>



                    </p>


                    <h5>V. നിക്ഷേപക സേവനങ്ങൾ </h5>
                    <p>
                        രജിസ്റ്റർ ചെയ്ത നിക്ഷേപകർക്ക് ഇനിപ്പറയുന്ന നിക്ഷേപ സേവനങ്ങൾക്കായി ഓൺലൈൻ പോർട്ടൽ ഉപയോഗിക്കാം:
                        <ol type="a">
                            <li> അക്കൗണ്ട് സ്റ്റേറ്റ്മെന്‍റ് </li>
                            <p>
                                റീട്ടെയിൽ ഡയറക്ട് ഗിൽറ്റ് അക്കൗണ്ടിലെ സെക്യൂരിറ്റി ഹോൾഡിംഗുകളുടെ ഇടപാട് ചരിത്രവും ബാലൻസ് നിലയും നൽകിയിരിക്കുന്ന ലിങ്കിൽ നിന്ന് ലഭിക്കും. എല്ലാ ഇടപാട് അലേർട്ടുകളും ഇ-മെയിൽ/എസ്.എം.എസ്. വഴി നൽകും.
                            </p>
                            <li>
                                നോമിനേഷൻ സൗകര്യം
                            </li>
                            <p>
                                നിശ്ചിത മാതൃകയിലുള്ള നോമിനേഷൻ ഫോം കൃത്യമായി ഒപ്പിട്ടു പൂരിപ്പിച്ച് അപ്‌ലോഡ് ചെയ്യാം. പരമാവധി രണ്ട് നോമിനികൾ ഉണ്ടാകാം. രജിസ്റ്റർ ചെയ്ത നിക്ഷേപകൻ മരണപ്പെട്ടാൽ, മരണ സർട്ടിഫിക്കറ്റും കൈമാറ്റം ചെയ്യാനുള്ള ഫോമും സമർപ്പിച്ചാൽ ആർ.ഡി.ജി. അക്കൗണ്ടിൽ ലഭ്യമായ സെക്യൂരിറ്റികൾ ആർ.ഡി.ജി. അക്കൗണ്ടിലേക്കോ നോമിനിയുടെ മറ്റേതെങ്കിലും സർക്കാർ സെക്യൂരിറ്റീസ് അക്കൗണ്ടിലേക്കോ മാറ്റാം.
                            </p>
                            <li>
                                ഈട് / പകരം
                            </li>
                            <p>
                                ആർ‌.ഡി‌.ജി. അക്കൗണ്ടിൽ സൂക്ഷിച്ചിരിക്കുന്ന സെക്യൂരിറ്റികൾ, ഈട്/പകരത്തിന് ലഭ്യമാകും
                            </p>
                            <li>
                                സമ്മാന ഇടപാടുകൾ
                            </li>
                            <p>
                                മറ്റ് റീട്ടെയിൽ ഡയറക്ട് നിക്ഷേപകർക്ക് സർക്കാർ സെക്യൂരിറ്റികൾ സമ്മാനിക്കുന്നതിന് ‘റീട്ടെയിൽ ഡയറക്ട് ഇൻവെസ്റ്റേഴ്സിന്’ ഓൺലൈൻ സൗകര്യം ഉണ്ടായിരിക്കും.
                            </p>
                            <li>
                                പരാതി പരിഹാരം
                            </li>
                            <p>
                                'റീട്ടെയിൽ ഡയറക്ട്' പദ്ധതിയുമായി ബന്ധപ്പെട്ട ഏത് അന്വേഷണവും പരാതികളും പോർട്ടലിൽ ഉന്നയിക്കാവുന്നതാണ്, അത് പബ്ലിക് ഡെറ്റ് ഓഫീസ് (പി.ഡി.ഒ.) മുംബൈ, RBI കൈകാര്യം ചെയ്യും/പരിഹരിക്കും.
                            </p>
                        </ol>
                    </p>
                    
                    <h5>VI. ഫീസും ചാർജുകളും </h5>
                    <p>
                        <ol type="a">
                            <li>
                                RBI-യിൽ 'റീട്ടെയിൽ ഡയറക്ട് ഗിൽറ്റ് അക്കൗണ്ട്' തുറക്കുന്നതിനും പരിപാലിക്കുന്നതിനും യാതൊരു ഫീസും ഈടാക്കില്ല.
                            </li>
                            <li>
                                പ്രൈമറി ലേലത്തിൽ ബിഡ് സമർപ്പിക്കുന്നതിന് അഗ്രിഗേറ്റർ യാതൊരു ഫീസും ഈടാക്കില്ല.
                            </li>
                            <li>
                                പേയ്‌മെന്‍റ് ഗേറ്റ്‌വേയ്ക്കും മറ്റും ബാധകമായ ഫീസ് രജിസ്റ്റർ ചെയ്ത നിക്ഷേപകൻ വഹിക്കും.
                            </li>
                        </ol>
                    </p>

                </div>
            </div>
        </section>
    </main>
    <Footer />
</div>
 ) };export default AbtSchemeUI 
